import * as React from 'react';
import { IsMobileDevice } from 'source/app/domain/Device/Helpers/IsMobile';
import { Animate } from '../../Shared/Animation/Animate';
import { Animations } from '../../Shared/Animation/Animations';
import { Curves } from '../../Shared/Animation/Curves';
import { IImageWithOverlayOptions, ImageWithOverlay } from '../../Shared/Image/ImageWithOverlay';
import Hyperlink from '../../Shared/Link/Hyperlink';
import Render from '../../Shared/Render';
import { StyleClass } from '../../Shared/Styles/CSS';
import { webkitFilterGlitchFix } from '../../Shared/Styles/SharedStyles';
import ShowPlayerDetails from './PlayerDetails/PlayerDetails';

const LevelBadge = ({ level }: { level: number }) => {
	const imageOptions = {
		imageLabel: `levelBadge_${level}`,
		imageWidth: 24,
		imageHeight: 26,
		imageUrl: '/images/icons/layered-armor-grit.svg',
		imageCSS: {
			display: `inline-flex`,
			zIndex: 1,
			opacity: level ? 1 : 0.2,
			filter: `brightness(${level ? 1 : 0}) drop-shadow(0px 3px 6px rgba(0,0,0,0.4))`,
			transition: IsMobileDevice() ? `` : `all 3s`,
			...webkitFilterGlitchFix
		}
	};

	return (
		<Hyperlink
			classes={StyleClass(`pnlLevelBadge_${level}`, {
				marginLeft: '4px',
				position: 'relative',
				left: '2px',
				float: 'left',
				top: `3px`
			})}
			whenClicked={() => ShowPlayerDetails()}
		>
			<Badge imageOptions={imageOptions} level={level} />
		</Hyperlink>
	);
};

export default LevelBadge;

const Badge = ({ imageOptions, level }: { imageOptions: IImageWithOverlayOptions; level: number }) => {
	const flashAnimation = Animations.Brighten(0.5).ForDuration(8000).PlayInfinitely().UsingCurve(Curves.Flash());

	return (
		<Animate animation={flashAnimation} playImmediately>
			<ImageWithOverlay options={imageOptions}>
				<LevelNumber level={level} />
			</ImageWithOverlay>
		</Animate>
	);
};

const LevelNumber = ({ level }: { level: number }) => (
	<Render
		id="levelNumber"
		when={level}
		withClasses={StyleClass(`levelNumber_badgeText_${level}`, {
			fontFamily: '"IM Fell French Canon SC"',
			fontWeight: 'bold',
			fontSize: '15px',
			opacity: 1,
			position: 'relative',
			bottom: `2px`,
			right: '0px',
			background: 'url(/images/icons/layered-armor-red.svg) no-repeat',
			WebkitBackgroundClip: 'text',
			backgroundClip: 'text',
			backgroundSize: '24px',
			width: '25px',
			paddingBottom: '6px',
			color: 'transparent',
			backgroundColor: 'transparent',
			filter: `hue-rotate(20deg) brightness(6.5) drop-shadow(0px 0px 1px black)`,
			...webkitFilterGlitchFix
		})}
	>
		{level}
	</Render>
);
